var map = {
	"./0.svg": 67,
	"./1.svg": 77,
	"./10.svg": 78,
	"./11.svg": 79,
	"./2.svg": 80,
	"./3.svg": 81,
	"./4.svg": 82,
	"./5.svg": 83,
	"./6.svg": 84,
	"./7.svg": 85,
	"./8.svg": 86,
	"./9.svg": 87,
	"./SVG/1.svg": 30,
	"./SVG/10.svg": 141,
	"./SVG/11.svg": 142,
	"./SVG/12.svg": 143,
	"./SVG/2.svg": 144,
	"./SVG/3.svg": 145,
	"./SVG/4.svg": 146,
	"./SVG/5.svg": 147,
	"./SVG/6.svg": 148,
	"./SVG/7.svg": 149,
	"./SVG/8.svg": 150,
	"./SVG/9.svg": 151,
	"./calc.svg": 88,
	"./clock.svg": 114,
	"./close.svg": 115,
	"./closebtn.svg": 116,
	"./edit.svg": 117,
	"./facebook.svg": 118,
	"./fullscreen.svg": 153,
	"./google.svg": 119,
	"./home-logo.svg": 76,
	"./human.svg": 89,
	"./humans.svg": 90,
	"./iWatch.svg": 155,
	"./logo.svg": 24,
	"./luck.svg": 91,
	"./nav.svg": 121,
	"./notify.svg": 92,
	"./preview.svg": 156,
	"./timestamp.svg": 93,
	"./unluck.svg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 296;